import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start Overview
export const getOverviewCustomerService = (params) => {
  return http.get(`${base_url}/customer/overview`, { params });
};
// End Overview

// Start Qr Code
export const getQrCodeCustomerService = () => {
  return http.get(`${base_url}/customer/qr-code`);
};
// End Qr Code
